import React from 'react';

// Datos que solo pide el contrato (31-oct-2026): quién alquila (el titular del CUIT con el que se factura,
// que puede no ser quien firma) y quién firma por la empresa. Los del locador quedan guardados en el navegador.
export const GUARDADO_LOCADOR = 'contrato_alquiler_locador';
export const LOCADOR_INICIAL = { nombre: '', cuit: '', firmante: '', cargoFirmante: '' };

export default function CamposContrato({ locador, setLocador, representante, setRepresentante, preaviso, setPreaviso, INPUT, Campo }) {
    const L = (k) => (e) => setLocador(p => ({ ...p, [k]: e.target.value }));
    const R = (k) => (e) => setRepresentante(p => ({ ...p, [k]: e.target.value }));
    return (
        <div className="space-y-3 rounded-xl border border-black/[0.07] dark:border-white/[0.07] p-3">
            <p className="text-caption text-muted">Locador: el titular del CUIT con el que facturás. Si firmás vos y no sos el titular, necesitás un poder o que firme el titular.</p>
            <div className="grid grid-cols-2 gap-2">
                <Campo label="Titular (locador)"><input className={INPUT} value={locador.nombre} onChange={L('nombre')} /></Campo>
                <Campo label="CUIT"><input className={INPUT} inputMode="numeric" value={locador.cuit} onChange={L('cuit')} /></Campo>
                <Campo label="Firma por el locador"><input className={INPUT} value={locador.firmante} onChange={L('firmante')} /></Campo>
                <Campo label="Carácter"><input className={INPUT} value={locador.cargoFirmante} onChange={L('cargoFirmante')} placeholder="Titular / Apoderado" /></Campo>
            </div>
            <Campo label="Firma por la empresa · nombre"><input className={INPUT} value={representante.nombre} onChange={R('nombre')} /></Campo>
            <div className="grid grid-cols-3 gap-2">
                <Campo label="DNI"><input className={INPUT} inputMode="numeric" value={representante.dni} onChange={R('dni')} /></Campo>
                <Campo label="Cargo" className="col-span-2"><input className={INPUT} value={representante.cargo} onChange={R('cargo')} placeholder="Socio gerente / Apoderado" /></Campo>
            </div>
            <Campo label="Aviso de baja (días)"><input className={INPUT} inputMode="numeric" value={preaviso} onChange={(e) => setPreaviso(e.target.value)} /></Campo>
        </div>
    );
}
